import { useState } from 'react'
import faqList from '../../data/haFaqList.json'
import { Accordion, Container } from 'react-bootstrap'

const HaFaq = () => {
  const [activeKey, setActiveKey] = useState(null)

  return (
    <Container style={{ backgroundColor: '#f4f4f4', paddingBottom: '2rem' }}>
      {faqList.map((item, index) => {
        return (
          <div key={index}>
            <h5
              style={{
                color: '#67C7AA',
                margin: '0 1rem 1rem',
                padding: '2rem 0 0',
              }}
            >
              {item.title}
            </h5>
            <Accordion>
              {item.list.map((questions, index) => {
                return (
                  <Accordion.Item
                    key={index}
                    eventKey={index.toString()}
                    style={{ color: '#666' }}
                  >
                    <Accordion.Header
                      onClick={() =>
                        setActiveKey(
                          activeKey === index.toString()
                            ? null
                            : index.toString()
                        )
                      }
                    >
                      {questions.question}
                    </Accordion.Header>
                    <Accordion.Body
                      style={{ whiteSpace: 'pre-wrap', lineHeight: '2' }}
                    >
                      {questions.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                )
              })}
            </Accordion>
          </div>
        )
      })}
      <div
        style={{ margin: '2rem', display: 'flex', justifyContent: 'center' }}
      >
        <a href="https://lin.ee/s6PupBc/?openExternalBrowser=1">
          <img
            alt="加入好友"
            src="https://i.postimg.cc/3Nncm713/line-add-friend.png"
            style={{ width: '200px' }}
          />
        </a>
      </div>
    </Container>
  )
}

export default HaFaq
